export default function CountryPrice({ priceUsd, currency }) {
  return (
    <>
      US${priceUsd.toLocaleString()}
      {currency.dollarExchangeRate !== 1 && (
        <>
          {' '}
          ({currency.symbol}{' '}
          {Math.round(priceUsd * currency.dollarExchangeRate).toLocaleString()})
        </>
      )}
    </>
  );
}
